module.exports = __webpack_public_path__ + "img/Nicole.eb9a5d49.jpeg";